export default __webpack_public_path__ + "static/media/Chelsea 9781408354988.8dbdab89.jpg";